import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Guest {
  id: number;
  guestId: number | null;
  altNm: string;
  firstNm: string;
  contact: string;
  rcountryId: number | null;
  countryId: number | null;
  postNo: string;
  provinceId: number | null;
  address1: string;
  email: string;
  certificate: string | null;
  signature: string;
  version: number;
};

interface InputState {
  receipt: string;
  version: number;
  guests: Guest[];
};

const initialState: InputState = {
  receipt: '',
  version: 0,
  guests: [],
};

type UpdateGuestPayload = {
  id: number;
  changes: Partial<Guest>;
};

const inputSlice = createSlice({
  name: 'input',
  initialState,
  reducers: {
    update(state, action: PayloadAction<{ key: string, value: any }>) {
      const { key, value } = action.payload;
      (state as any)[key] = value;
    },
    addGuest: (state, action: PayloadAction<Guest>) => {
      state.guests.push(action.payload);
    },
    removeGuest: (state, action: PayloadAction<number>) => {
      state.guests = state.guests.filter(guest => guest.id !== action.payload);
    },
    updateGuest(state, action: PayloadAction<UpdateGuestPayload>) {
      const { id, changes } = action.payload;
      const guestIndex = state.guests.findIndex(guest => guest.id === id);
      if (guestIndex !== -1) {
        state.guests[guestIndex] = {
          ...state.guests[guestIndex],
          ...changes
        };
      }
    },
    reset: () => initialState,
  },
});

export const { update, addGuest, removeGuest, updateGuest, reset } = inputSlice.actions;

export default inputSlice.reducer;
